<template>
  <div class="checkbox-container">
    <input type="radio" :id="this.idAnalytics" v-on:change="handleSelectPassion"
      :checked="passionSelected ? passionSelected === this.name : featureSelected === this.name" />
    <label class="custom-checkbox" :for="this.idAnalytics">
      <img :src="this.imageBackground" />
      <div :class="this.description ? 'footer-card-tv padding' : 'footer-card-tv'">
        <h4 class="title-checkbox-card">{{ this.title }}</h4>
        <!-- <template v-if="this.description">
            <p>{{this.description}}</p>
          </template> -->
        <template v-if="this.description" style="padding-top: 8px">
          <!-- <p>{{this.description}}</p> -->
          <FeatureDescription v-for="(desc, index) in description" :key="index" :content="desc"></FeatureDescription>
          <!-- <p v-html="this.description"></p> -->
        </template>
        <template v-if="this.priceScale">
          <PriceScale :scale="this.priceScale" :maxValue="5" />
        </template>
      </div>
    </label>
  </div>
</template>

<script>

import PriceScale from './PriceScale.vue';
import FeatureDescription from './FeatureDescription.vue';

export default {
  name: "CheckboxCard",
  components: {
    PriceScale,
    FeatureDescription
  },
  props: [
    "sendAnalytics",
    "name",
    "imageBackground",
    "title",
    "description",
    "passionSelected",
    "featureSelected",
    "isPassion",
    "idAnalytics",
    "priceScale"
  ],
  data() {
    return {};
  },
  computed: {},
  mounted() { },
  methods: {
    handleSelectPassion() {
      this.isPassion === true ? this.$emit('selectPassion', this.name) : this.$emit('selectFeature', this.name)
            
    },
  },
};
</script>

<style lang="scss">
input[type="checkbox"][id^="checkbox-card"] {
  display: none;
}

.checkbox-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1% 0;


  input {
    display: none;
  }
}

.custom-checkbox {
  display: block;
  justify-content: center;

  flex-direction: column;

  position: relative;

  width: max-content;

  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: solid 2px #fff;
  border-radius: 0.75rem;
  overflow: hidden;
  max-width: 244px;

  /* &:hover{
    border: solid 2px #6E6A69;
  } */

  img {
    height: 150px;
    width: 240px;
    transition-duration: 0.2s;
    transform-origin: 50% 50%;

  }

  .footer-card-tv {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    flex-direction: column;

    text-align: center;

    background-color: #FFF;

    padding: 7px;


    p {
      font-family: $font-family-default;
      color: #1E1E1E;
      font-size: 0.750rem;
      line-height: 1rem;

      // padding-top: 8px;

      max-width: 200px;
    }
  }

  .padding {
    padding: 20px;
    min-height: 160px;
  }

  .title-checkbox-card {
    font-family: $font-family-default-bold;
    font-size: 14px;
    line-height: 20px;

    white-space: pre-line;

    color: #2E2C2B;

    max-width: 200px;

    transition-duration: 0.2s;

    padding-bottom: 8px;
  }
}

.slick-active.slick-center.slick-current {
  .custom-checkbox {
    border: solid 2px #6E6A69;
  }
}

.custom-checkbox::before {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  text-align: center;

  content: " ";

  background-color: #FFF;
  color: #FFF;

  border-radius: 50%;
  border: 2px solid #000;

  top: 1.25rem;
  right: 1.56rem;

  width: 24px;
  height: 24px;

  transition-duration: 0.4s;
  z-index: 1;

}

.custom-checkbox:hover {

  border: solid 2px #6E6A69;
} 

.slick-active.slick-center.slick-current :checked+.custom-checkbox {

  border: solid 2px #1428A0;
  -webkit-box-shadow: 0px 0px 0px 2px #1428A0;
  -moz-box-shadow: 0px 0px 0px 2px #1428A0;
  box-shadow: 0px 0px 0px 2px #1428A0;
}

:checked+.custom-checkbox {

  border: solid 2px #1428A0;
  -webkit-box-shadow: 0px 0px 0px 2px #1428A0;
  -moz-box-shadow: 0px 0px 0px 2px #1428A0;
  box-shadow: 0px 0px 0px 2px #1428A0;

}

input:checked+.custom-checkbox::before {
  content: url("../assets/checked.png");
  background-color: $color-primary;
  border-color: $color-primary;
  transform: scale(1);
}

@media(max-width: 768px) {
  .custom-checkbox {
    margin: 0 auto;
    width: 95%;
  }

  .custom-checkbox img {
    object-fit: cover;
    width: 100%;
  }

  // .checkbox-container {
  //   padding: 10px 0;
  // }

}
</style>